import React, { useCallback, useState } from "react";
import { Box, Button, CircularProgress } from "@mui/material";

import { useFeatureFlag } from "fond/featureFlags";
import { LogViewerModal } from "fond/widgets";

import { LogsOutput } from "./useCustomWorkflow";

type UseWorkflowErrorLogsResult = {
  errorLogsInline: React.ReactNode;
  logsModal: React.ReactNode;
};

const useWorkflowErrorLogs = (logs: LogsOutput | null): UseWorkflowErrorLogsResult => {
  const [isLogsModalOpen, setIsLogsModalOpen] = useState(false);
  const { value: isCustomWorkflowErrorLogsEnabled } = useFeatureFlag("custom_workflow_error_logs");
  const handleViewLogs = useCallback(() => setIsLogsModalOpen(true), []);

  if (!isCustomWorkflowErrorLogsEnabled) {
    return { errorLogsInline: null, logsModal: null };
  }

  const errorLogsInline = (
    <Box mt={1}>
      {logs?.type === "waiting" && (
        <Box display="flex" alignItems="center" gap={1}>
          <CircularProgress size={12} color="inherit" />
          Attempting to process logs
        </Box>
      )}
      {logs?.type === "ready" && logs.logs.length === 0 && "Error logs are not available."}
      {logs?.type === "ready" && logs.logs.length > 0 && (
        <Button size="small" variant="outlined" color="error" onClick={handleViewLogs}>
          View Logs
        </Button>
      )}
    </Box>
  );

  const logsModal =
    logs?.type === "ready" ? <LogViewerModal open={isLogsModalOpen} onClose={() => setIsLogsModalOpen(false)} logs={logs.logs} title="Logs" /> : null;

  return { errorLogsInline, logsModal };
};

export default useWorkflowErrorLogs;
